/**
 * Moved to `modules/shared/lib/report-utils` so the authenticated app
 * (historical metrics drill-down) can reuse the answer-rendering pipeline.
 * This shim keeps the public report's import paths stable.
 *
 * NOTE: uses a RELATIVE path, not the `@shared` alias, because non-web
 * packages import this file via a relative path into apps/web
 * (packages/background-jobs test) and can't resolve web-only tsconfig aliases.
 */
export * from "../../../shared/lib/report-utils";
